var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Performance Daten bearbeiten","action":"update","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('performance-form',{attrs:{"facebook":_vm.facebook,"google":_vm.google}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }